/**
 * Homeowner document folders and the share rule agents are held to.
 * Required from Netlify functions: no object spread.
 */

const DEFAULT_FOLDER_NAME = 'Unfiled';
const SUGGESTED_FOLDER_NAMES = ['Receipts', 'Warranties', 'Insurance', 'Reports'];
const MAX_FOLDER_NAME = 40;

function cleanFolderName(value) {
  return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
}

function folderNameError(value) {
  const name = cleanFolderName(value);
  if (!name) return 'Enter a folder name.';
  if (name.length > MAX_FOLDER_NAME) return 'Use 40 characters or fewer.';
  return '';
}

function sameFolderName(left, right) {
  return cleanFolderName(left).toLowerCase() === cleanFolderName(right).toLowerCase();
}

/** A document is shared when its own switch is on, or its folder is shared. */
function documentIsShared(doc, folder) {
  if (!doc) return false;
  if (doc.shared_with_agent === true) return true;
  return !!(folder && folder.shared_with_agent === true);
}

/**
 * Same predicate as private.document_visible_to_agent, minus the client check.
 * Revoking either switch drops the row on the next read.
 */
function agentCanReadRow(doc, folder) {
  if (!doc) return false;
  if (doc.created_by === 'agent') return true;
  return documentIsShared(doc, folder);
}

/**
 * Rows already returned by RLS omit the new columns in older mocks.
 * Hide a row only when the payload explicitly says it is not shared.
 */
function agentMayShowDocument(doc) {
  if (!doc) return false;
  if (doc.created_by === 'agent') return true;
  if (doc.shared_with_agent === true) return true;
  if (doc.folder_shared === true) return true;
  if (doc.shared_with_agent === false) return false;
  return true;
}

function folderSubtitle(count, sharedCount) {
  const total = Number(count) || 0;
  const shared = Number(sharedCount) || 0;
  const noun = total === 1 ? 'document' : 'documents';
  if (!shared) return total + ' ' + noun;
  const sharedLabel = shared === 1 ? '1 shared' : shared + ' shared';
  return total + ' ' + noun + ' · ' + sharedLabel;
}

module.exports = {
  DEFAULT_FOLDER_NAME,
  SUGGESTED_FOLDER_NAMES,
  MAX_FOLDER_NAME,
  cleanFolderName,
  folderNameError,
  sameFolderName,
  documentIsShared,
  agentCanReadRow,
  agentMayShowDocument,
  folderSubtitle,
};
